import angular from 'angular';
import fullBetName from './fullBetNameFilter';
import capitalize from './capitalizeFilter';
import arrayService from './createArrayService';
import nabTrans from './transService';
// this is an old module that is deprecated
// and all parts should moved to 7Shop.Common
const moduleName = angular.module('ngLib', [])
  .filter('fullBetName', fullBetName)
  .filter('capitalize', capitalize)
  .service('arrayService', arrayService)
  .service('nabTrans', nabTrans)
  .name;

export default moduleName;
